<rask-page>
  <ng-container header class="rask-preview-viol3-page">
    <rask-checkbox text="Visa utkast" [(ngModel)]="visaUtkast" (change)="utkastChange()"></rask-checkbox>
  </ng-container>

  @if (dto && dto?.contracts && dto.contracts.length > 1){
    @if (dto && dto?.contracts) {
      <rask-tabs parameterName="section" class="parent" [size]="4" [wrap]="true">
        @for (data of dto?.contracts; track data; let i = $index) {
          <rask-tab [label]="data.documentNumber" [routeId]="data.documentNumber" class="rask-preview-viol3-page">
            <rask-viol3-kontrakt [kontraktData]="data"></rask-viol3-kontrakt>
          </rask-tab>
        }
      </rask-tabs>
    }
  }
  @else if(dto && dto?.contracts && dto.contracts.length === 1)
  {
  <rask-header>{{dto.contracts[0].documentNumber}}</rask-header>
  <rask-viol3-kontrakt [kontraktData]="dto.contracts[0]"></rask-viol3-kontrakt>
}
</rask-page>